import React from 'react';
import { XCircle } from 'lucide-react';
export function Problem() {
  const failures = ['Standard "wake windows" are generic averages that ignore your baby\'s specific cortisol triggers.', "White noise and dark rooms are just crutches; they don't solve the biological stress preventing sleep.", '"Cry It Out" methods often backfire on sensitive newborns, causing higher stress for both of you.', 'Rhythmic bouncing and shushing often provide too much stimulation when the brain needs stillness.'];
  return <section className="bg-cream py-20 px-6" data-id="element-83">
      <div className="max-w-4xl mx-auto" data-id="element-84">
        <div className="mb-16" data-id="element-85">
          <h2 className="text-3xl md:text-4xl font-serif text-center mb-8" data-id="element-86">
            Why Standard Sleep Advice Fails
          </h2>
          <div className="space-y-6 text-lg font-sans text-charcoal/80 leading-relaxed" data-id="element-87">
            <p data-id="element-88">
              Most sleep advice fails because it treats your baby like a machine
              to be programmed. They tell you to "just let them cry" or "put
              them down drowsy but awake"—advice that feels impossible when your
              baby is screaming in a cortisol spike.
            </p>
            <p data-id="element-89">
              When your baby misses a sleep window by even five minutes, their
              brain enters "Fight or Flight" mode. They aren't being stubborn;
              they are chemically unable to shut down. You aren't doing anything
              wrong; you’re just trying to force an overwhelmed nervous system
              to do something it can’t do yet.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-sage/20" data-id="element-90">
          <h3 className="text-2xl font-serif mb-8 text-center" data-id="element-91">
            Why What You Tried Didn't Work
          </h3>
          <ul className="space-y-6" data-id="element-92">
            {failures.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-93">
                <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-1" data-id="element-94" />
                <span className="text-lg font-sans text-charcoal/80" data-id="element-95">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}